import { render, staticRenderFns } from "./DynamicDepositButton.vue?vue&type=template&id=015e9345"
import script from "./DynamicDepositButton.vue?vue&type=script&lang=js"
export * from "./DynamicDepositButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports